<template>
  <div class="dialog_container">
    <el-dialog
      title="编辑车辆信息"
      :visible="dialogShow"
      width="1288px"
      @close="dialogClose"
      top="5vh"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="dialog_box">
        <div class="form_title">基本信息</div>
        <el-form
          ref="redactForm"
          class="chang_car_config_from"
          :model="redactForm"
          label-width="140px"
          :rules="redactRules"
        >
          <el-form-item label="车辆营运性质：">
            <el-select v-model="redactForm.carServiceStr" disabled>
              <el-option
                v-for="item in carServiceList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆厂商：" prop="carFactory">
            <el-input
              v-model="redactForm.carFactory"
              placeholder="请输入车辆厂商"
            ></el-input>
          </el-form-item>
          <el-form-item label="车架号VIN：">
            <el-input
              v-model="redactForm.vin"
              placeholder="请输入车架号VIN"
            ></el-input>
          </el-form-item>
          <el-form-item label="发动机号码：" prop="engineSn">
            <el-input
              v-model="redactForm.engineSn"
              placeholder="请输入发动机号码"
            ></el-input>
          </el-form-item>
          <div class="flex_form">
            <el-form-item label="满载总质量：">
              <el-input
                class="short_ipt"
                v-model="redactForm.fullyLaden"
                placeholder="请输入满载总质量"
              ></el-input>
              <div class="unit">kg</div>
            </el-form-item>
          </div>
          <div class="flex_box">
            <el-form-item label="长：" class="min_form-item">
              <el-input
                class="min_ipt"
                v-model="redactForm.carSpecsLong"
              ></el-input>
              <div class="mm_text">mm X</div>
            </el-form-item>
            <el-form-item label="宽：" class="min_form-item">
              <el-input
                class="min_ipt"
                v-model="redactForm.carSpecsWidth"
              ></el-input>
              <div class="mm_text">mm X</div>
            </el-form-item>
            <el-form-item label="高：" class="min_form-item">
              <el-input
                class="min_ipt"
                v-model="redactForm.carSpecsHigh"
              ></el-input>
              <div class="mm_text">mm</div>
            </el-form-item>
          </div>
          <div class="flex_form">
            <el-form-item label="整备质量：">
              <el-input
                class="short_ipt"
                v-model="redactForm.curbWeight"
                placeholder="请输入整备质量"
              ></el-input>
              <div class="unit">kg</div>
            </el-form-item>
          </div>
          <div class="flex_form">
            <el-form-item label="准牵引质量：">
              <el-input
                class="short_ipt"
                v-model="redactForm.tractionMass"
                placeholder="请输入准牵引质量"
              ></el-input>
              <div class="unit">kg</div>
            </el-form-item>
          </div>
          <div class="flex_form">
            <el-form-item label="核定载质量：">
              <el-input
                class="short_ipt"
                v-model="redactForm.approvedLaden"
                placeholder="请输入核定载质量"
              ></el-input>
              <div class="unit">kg</div>
            </el-form-item>
          </div>
          <div class="flex_form">
            <el-form-item label="核定载客：">
              <el-input
                class="short_ipt"
                v-model="redactForm.approvedPerson"
                placeholder="请输入核定载客"
              ></el-input>
              <div class="unit">人</div>
            </el-form-item>
          </div>
          <el-form-item label="制造厂名：">
            <el-input
              v-model="redactForm.createName"
              placeholder="请输入制造厂名"
            ></el-input>
          </el-form-item>
          <el-form-item label="出厂日期：">
            <el-date-picker
              v-model="redactForm.createTimeStr"
              type="date"
              placeholder="请选择出厂日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="国产/进口：">
            <el-select
              v-model="redactForm.isDomesticStr"
              placeholder="请选择发证机构"
            >
              <el-option
                v-for="item in isDomesticList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="底盘型号：">
            <el-input
              v-model="redactForm.chassisModel"
              placeholder="请输入地盘型号"
            ></el-input>
          </el-form-item>
          <el-form-item label="发动机型号：">
            <el-input
              v-model="redactForm.engineModel"
              placeholder="请输入发动机型号"
            ></el-input>
          </el-form-item>
          <el-form-item label="货厢内尺寸或容积：">
            <el-input
              v-model="redactForm.containerSize"
              placeholder="请输入货厢内尺寸或容积"
            ></el-input>
          </el-form-item>
          <div class="flex_form">
            <el-form-item label="发动机排量：">
              <el-input
                class="short_ipt"
                v-model="redactForm.engineDisplacement"
                placeholder="请输入发动机排量"
              ></el-input>
              <div class="unit">L</div>
            </el-form-item>
          </div>
          <div class="flex_form">
            <el-form-item label="发动净功率：">
              <el-input
                class="short_ipt"
                v-model="redactForm.enginePower"
                placeholder="请输入发动净功率"
              ></el-input>
              <div class="unit">KW</div>
            </el-form-item>
          </div>

          <el-form-item label="排放标准：">
            <el-select
              v-model="redactForm.emissionStandard"
              placeholder="请选择排放标准"
            >
              <el-option
                v-for="item in emissionStandardList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="电池类型：">
            <el-input
              v-model="redactForm.batteryType"
              placeholder="请输入电池类型"
            ></el-input>
          </el-form-item>
          <el-form-item label="驱动电机型号：">
            <el-input
              v-model="redactForm.motorModel"
              placeholder="请输入驱动电机型号"
            ></el-input>
          </el-form-item>
          <el-form-item label="电机功率：">
            <el-input
              v-model="redactForm.motorPower"
              placeholder="请输入电机功率"
            ></el-input>
          </el-form-item>
          <el-form-item label="动力类型：">
            <el-select
              v-model="redactForm.powerType"
              placeholder="请选择动力类型"
            >
              <el-option
                v-for="item in powerTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div class="flex_form">
            <el-form-item label="轴距（轮距）：">
              <el-input
                class="short_ipt"
                v-model="redactForm.vehWheelbase"
                placeholder="请输入轴距（轮距）"
              ></el-input>
              <div class="unit">mm</div>
            </el-form-item>
          </div>
          <el-form-item label="车轴数：">
            <el-input
              v-model="redactForm.axlesNum"
              placeholder="请输入车轴数"
            ></el-input>
          </el-form-item>
          <el-form-item label="驱动：">
            <el-input
              v-model="redactForm.vehDrive"
              placeholder="请输入驱动"
            ></el-input>
          </el-form-item>
          <el-form-item label="轮胎数：">
            <el-input
              v-model="redactForm.tyreNum"
              placeholder="请输入轮胎数"
            ></el-input>
          </el-form-item>
          <el-form-item label="轮胎规格：">
            <el-input
              v-model="redactForm.tyreType"
              placeholder="请输入轮胎规格"
            ></el-input>
          </el-form-item>
          <el-form-item label="行车制动方式：">
            <el-select
              v-model="redactForm.serviceBrake"
              placeholder="请选择行车制动方式"
            >
              <el-option
                v-for="item in serviceBrakeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="ABS：">
            <el-select v-model="redactForm.isAbs" placeholder="请选择ABS">
              <el-option
                v-for="item in yeOrNoList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="制动器型式（前轮）：">
            <el-select
              v-model="redactForm.brakeType1"
              placeholder="请选择制动器型式（前轮）"
            >
              <el-option
                v-for="item in brakeTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="制动器型式（后轮）：">
            <el-select
              v-model="redactForm.brakeType2"
              placeholder="请选择制动器型式（后轮）"
            >
              <el-option
                v-for="item in brakeTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="变速器型式：">
            <el-select
              v-model="redactForm.transmissionType"
              placeholder="请选择变速器型式"
            >
              <el-option
                v-for="item in transmissionTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="缓速器：">
            <el-select v-model="redactForm.isRetarder" placeholder="请选缓速器">
              <el-option
                v-for="item in yeOrNoList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="空调系统：">
            <el-select
              v-model="redactForm.isAirConditioner"
              placeholder="请选择空调系统"
            >
              <el-option
                v-for="item in yeOrNoList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="卫星定位装置：">
            <el-select
              v-model="redactForm.isLocation"
              placeholder="请选择卫星定位装置"
            >
              <el-option
                v-for="item in yeOrNoList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3 }"
              v-model="redactForm.remark"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm('redactForm')"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {dateTransition} from '@/utils/util';
export default {
  name: "",
  data() {
    return {
      textarea: "",
      redactForm: {},
      receiveList: [],
      carServiceList: [], // 车辆营运性质
      isDomesticList: [], // 国产/进口
      emissionStandardList: [], // 排放标准
      powerTypeList: [], // 动力类型
      serviceBrakeList: [], // 行车制动方式
      brakeTypeList: [], // 制动器型式
      transmissionTypeList: [], // 变速器型式
      yeOrNoList: [], // 有无
      redactRules: {
        engineSn: [
          { required: true, message: "请输入发动机型号", trigger: "blur" },
        ],
        carFactory: [
          { required: true, message: "请输入车辆厂商", trigger: "blur" },
        ],
      },
    };
  },
  components: {},
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      default: {},
    },
  },
  watch: {
    dialogShow(val) {
      console.log(val);
      if (val) {
        this.getConfigDataSelect();
        this.redactForm = this.dialogData;
        if (this.dialogData.createTime) {
          this.redactForm.createTimeStr = new Date(this.dialogData.createTime);
        }
      }
    },
  },
  created() {},
  methods: {
    getConfigDataSelect() {
      // 1车辆营运性质 2国产/进口 3排放标准 4动力类型 5行车制动方式 6有/无 7制动器型式 8变速器型式
      this.$http.getCarParamSelect(1).then((res) => {
        if (res.code === 0) {
          this.carServiceList = res.data;
        } else {
          this.carServiceList = [];
        }
      });
      this.$http.getCarParamSelect(2).then((res) => {
        if (res.code === 0) {
          this.isDomesticList = res.data;
        } else {
          this.isDomesticList = [];
        }
      });
      this.$http.getCarParamSelect(3).then((res) => {
        if (res.code === 0) {
          this.emissionStandardList = res.data;
        } else {
          this.emissionStandardList = [];
        }
      });
      this.$http.getCarParamSelect(4).then((res) => {
        if (res.code === 0) {
          this.powerTypeList = res.data;
        } else {
          this.powerTypeList = [];
        }
      });
      this.$http.getCarParamSelect(5).then((res) => {
        if (res.code === 0) {
          this.serviceBrakeList = res.data;
        } else {
          this.serviceBrakeList = [];
        }
      });
      this.$http.getCarParamSelect(6).then((res) => {
        if (res.code === 0) {
          this.yeOrNoList = res.data;
        } else {
          this.yeOrNoList = [];
        }
      });
      this.$http.getCarParamSelect(7).then((res) => {
        if (res.code === 0) {
          this.brakeTypeList = res.data;
        } else {
          this.brakeTypeList = [];
        }
      });
      this.$http.getCarParamSelect(8).then((res) => {
        if (res.code === 0) {
          this.transmissionTypeList = res.data;
        } else {
          this.transmissionTypeList = [];
        }
      });
    },
    confirm(formName) {
      if (this.redactForm.fullyLaden) {
        if (
          typeof (this.redactForm.fullyLaden * 1) == "number" &&
          isNaN(this.redactForm.fullyLaden * 1)
        ) {
          this.$message.error("满载总质量只能是数字");
          return;
        }
      }
      if (
        this.redactForm.carSpecsLong ||
        this.redactForm.carSpecsWidth ||
        this.redactForm.carSpecsHigh
      ) {
        if (
          (typeof (this.redactForm.carSpecsLong * 1) == "number" &&
            isNaN(this.redactForm.carSpecsLong * 1)) ||
          (typeof (this.redactForm.carSpecsWidth * 1) == "number" &&
            isNaN(this.redactForm.carSpecsWidth * 1)) ||
          (typeof (this.redactForm.carSpecsHigh * 1) == "number" &&
            isNaN(this.redactForm.carSpecsHigh * 1))
        ) {
          this.$message.error("长宽高只能是数字");
          return;
        }
      }
      if (this.redactForm.curbWeight) {
        if (
          typeof (this.redactForm.curbWeight * 1) == "number" &&
          isNaN(this.redactForm.curbWeight * 1)
        ) {
          this.$message.error("整备质量只能是数字");
          return;
        }
      }
      if (this.redactForm.tractionMass) {
        if (
          typeof (this.redactForm.tractionMass * 1) == "number" &&
          isNaN(this.redactForm.tractionMass * 1)
        ) {
          this.$message.error("准牵引质量只能是数字");
          return;
        }
      }
      if (this.redactForm.approvedLaden) {
        if (
          typeof (this.redactForm.approvedLaden * 1) == "number" &&
          isNaN(this.redactForm.approvedLaden * 1)
        ) {
          this.$message.error("核定载质量只能是数字");
          return;
        }
      }
      if (this.redactForm.approvedPerson) {
        if (
          typeof (this.redactForm.approvedPerson * 1) == "number" &&
          isNaN(this.redactForm.approvedPerson * 1)
        ) {
          this.$message.error("核定载客只能是数字");
          return;
        }
      }
      if (this.redactForm.engineDisplacement) {
        if (
          typeof (this.redactForm.engineDisplacement * 1) == "number" &&
          isNaN(this.redactForm.engineDisplacement * 1)
        ) {
          this.$message.error("发动机排量只能是数字");
          return;
        }
      }
      if (this.redactForm.enginePower) {
        if (
          typeof (this.redactForm.enginePower * 1) == "number" &&
          isNaN(this.redactForm.enginePower * 1)
        ) {
          this.$message.error("发动净功率只能是数字");
          return;
        }
      }
      if (this.redactForm.motorPower) {
        if (
          typeof (this.redactForm.motorPower * 1) == "number" &&
          isNaN(this.redactForm.motorPower * 1)
        ) {
          this.$message.error("电机功率只能是数字");
          return;
        }
      }
      if (this.redactForm.vehWheelbase) {
        if (
          typeof (this.redactForm.vehWheelbase * 1) == "number" &&
          isNaN(this.redactForm.vehWheelbase * 1)
        ) {
          this.$message.error("轴距（轮距）只能是数字");
          return;
        }
      }
      if (this.redactForm.axlesNum) {
        if (
          typeof (this.redactForm.axlesNum * 1) == "number" &&
          isNaN(this.redactForm.axlesNum * 1)
        ) {
          this.$message.error("车轴数只能是数字");
          return;
        }
      }
      if (this.redactForm.tyreNum) {
        if (
          typeof (this.redactForm.tyreNum * 1) == "number" &&
          isNaN(this.redactForm.tyreNum * 1)
        ) {
          this.$message.error("轮胎数只能是数字");
          return;
        }
      }
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        if(this.redactForm.createTimeStr){
          this.redactForm.createTimeStr = dateTransition(this.redactForm.createTimeStr)
        }
        this.$http.updateCarParam(this.redactForm).then((res) => {
          if (res.code === 0) {
            this.$message.success(res.msg);
            this.$parent.getList();
            this.redactForm = {};
            this.$emit("update:dialogShow", false);
          } else {
            this.$message.info(res.msg);
          }
        });
      });
    },
    dialogClose() {
      this.redactForm = {};
      this.$emit("update:dialogShow", false);
    },
  },
};
</script>

<style lang="less" scoped>
.dialog_box {
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  padding: 22px 0 40px;

  .form_title {
    width: 100%;
    position: relative;
    font-size: 20px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    padding-left: 16px;
    box-sizing: border-box;
    margin-bottom: 12px;

    .astrict_text {
      margin-left: 10px;
      font-size: 13px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #6e6e6e;
    }
  }

  .form_title::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 6px;
    height: 18px;
    background-color: #8eafff;
  }

  .chang_car_config_from {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    /deep/.el-textarea__inner {
      width: 678px;
    }
    /deep/.el-form-item__label {
      white-space: nowrap;
    }

    /deep/.el-input__inner {
      width: 250px;
      height: 36px;
      line-height: 36px;
    }

    .short_ipt {
      /deep/.el-input__inner {
        width: 220px;
        height: 36px;
        line-height: 36px;
      }
    }

    .flex_box {
      display: flex;
      width: 380px;
      justify-content: space-between;

      /deep/.el-form-item__label {
        width: 20px;
      }

      .min_form-item {
        width: 126px;
        position: relative;

        .mm_text {
          position: absolute;
          top: 0;
          left: 65px;
          white-space: nowrap;
          font-size: 12px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #434343;
        }
      }

      /deep/.el-form-item__label {
        width: 30px !important;
      }

      /deep/.el-form-item__content {
        width: 0px;
        margin-left: 20px !important;
      }

      .min_ipt {
        width: 50px;

        /deep/.el-input__inner {
          width: 100%;
          height: 36px;
          line-height: 36px;
        }
      }
    }

    .flex_form {
      position: relative;
      .unit {
        position: absolute;
        top: 0;
        right: 0;
      }
    }

    .el-select {
      width: 100%;
    }

    /deep/.el-form-item__content {
      width: 250px;
      height: 36px;
    }
  }
}
.dialog-footer {
  display: flex;
  justify-content: center;

  .btn {
    padding: 0;
    width: 105px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    border-radius: 4px;
    border: 1px solid #717171;
  }

  .btn_ok {
    background: #255A7E;
    color: #fff;
    border: none;
  }
}
/deep/.el-dialog__body {
  max-height: 70vh;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carTechnology_component/tabDialog/changCarConfig.vue